export default __webpack_public_path__ + "static/media/MailAutomation.a1add222.svg";